var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value != null)?_c('div',{staticClass:"blob-container"},[_c('img',{style:(_vm.image_style),attrs:{"src":_vm.img_src_url}}),_c('br'),_c('v-icon',{on:{"click":_vm.onClickDelete}},[_vm._v(" mdi-trash-can-outline ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }